import React from 'react';
import './About.css';

const About = () => {
  return (
    <section className="section about-section">
      <h2 className="section-title">Abstract</h2>
      
      <div className="about-content">
        <p className="about-paragraph">
          Kolosian is an independent AI research lab focused on the architectural foundations 
          of neural networks. We investigate how specialized sub-networks, routing mechanisms, 
          and decomposition strategies contribute to stable, interpretable, and efficient 
          reasoning systems.
        </p>
        
        <p className="about-paragraph">
          Our work emphasizes structural clarity over scale. Rather than building larger 
          monolithic models, we explore multi-stream architectures that enable dynamic 
          specialization, improved stability during training, and post-hoc interpretability 
          through architectural decomposition.
        </p>
        
        <p className="about-paragraph">
          We publish openly and collaborate with researchers who share an interest in 
          understanding intelligence through the lens of network architecture, modularity, 
          and emergence.
        </p>
      </div>
    </section>
  );
};

export default About;